<template>
  <div class="group">
    <input type="checkbox" id="feedbackConsent" name="feedbackConsent" v-model="$parent.fields.feedbackConsent">
    <label for="feedbackConsent">By submitting, I consent to ResMed using my product feedback for any of its marketing purposes in perpetuity.</label>
  </div>
</template>

<script>
    import mixin from './mixin';

    export default {
        name: 'feedbackConsent',
        data() {
            return {
                active: false
            }
        },
        mixins: [ mixin ]
    }
</script>
